<div class="container-fluid h-100 d-flex justify-content-center align-items-center flex-column login-container">
  <div class="row justify-content-center mt-5 mb-3">
    <img *ngIf="domain?.logoUrl" class="navbar-brand__img-l login-logo" [attr.src]="domain?.logoUrl" alt="Brand Logo"/>
  </div>
  <div class="login-content login-toastr-container">
    <div class="toastr-relative toastr-sm toastr-no-shadow mb-1" toastContainer></div>
  </div>
  <div   *ngIf="gologin" >
    <div class="row">
      <div class="col-12">
        <wsb-atlas-button class="float-right" [label]="'back_login'" [roundButton]="true" (click) = "goLogin()"></wsb-atlas-button>
      </div>
    </div>
  </div>
</div>
